/**
 * @generated SignedSource<<5fe0cee1f2787cf081880af5d7b58ebf>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavCreateListing_buttons$data = ReadonlyArray<{
  readonly eventName: string | null;
  readonly href: string | null;
  readonly interactionType: string | null;
  readonly text: string | null;
  readonly " $fragmentType": "NavCreateListing_buttons";
}>;
export type NavCreateListing_buttons$key = ReadonlyArray<{
  readonly " $data"?: NavCreateListing_buttons$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavCreateListing_buttons">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "NavCreateListing_buttons",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "href",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "interactionType",
      "storageKey": null
    }
  ],
  "type": "NavBarButton",
  "abstractKey": null
};

(node as any).hash = "5d2a2d5c74c6f2bbbd317b37886df842";

export default node;
